// extracted by mini-css-extract-plugin
export default {"wrap":"AssesmentCard_wrap__KUJTd","thumbnail":"AssesmentCard_thumbnail__bUQDR","content":"AssesmentCard_content__nFOU9","item":"AssesmentCard_item__o0k-l"};